module.exports = __webpack_public_path__ + "img/right_worm_n4_2.prt.369d9950.jpg";